// TODO:  implement ITheme and define color transition to the dark theme
import type { ITheme } from './theme.interface';

export const darkTheme = {} as ITheme;
